// src/services/api/scheduleRecommendations.ts
import { getFunctions, httpsCallable } from 'firebase/functions';
import {
  GetScheduleRecommendationsRequest,
  GetScheduleRecommendationsResponse,
  TimeRecommendation
} from '../../types/scheduleRecommendation';
import { logDev, logError } from '../../utils/logger';

/**
 * 獲取 AI 時間建議服務
 */
export const scheduleRecommendationService = {
  /**
   * 獲取任務的 AI 時間建議
   * @param request 請求參數
   * @returns AI 生成的時間建議
   */
  getRecommendations: async (
    request: GetScheduleRecommendationsRequest
  ): Promise<TimeRecommendation[]> => {
    try {
      logDev('ScheduleRecommendations', '開始請求 AI 時間建議', {
        taskId: request.task.id,
        taskTitle: request.task.title,
      });

      const functions = getFunctions();
      const getRecommendationsFn = httpsCallable<
        GetScheduleRecommendationsRequest,
        GetScheduleRecommendationsResponse
      >(functions, 'getScheduleRecommendations');

      // 設置預設參數
      const requestWithDefaults: GetScheduleRecommendationsRequest = {
        ...request,
        options: {
          // currentDate 由後端計算，不再由前端傳遞
          count: request.options?.count || 3,
        },
      };

      const response = await getRecommendationsFn(requestWithDefaults);

      if (!response.data || !response.data.recommendations) {
        throw new Error('Invalid response from AI service');
      }

      // 轉換日期字串為 Date 物件
      const recommendations = response.data.recommendations.map((rec) => ({
        ...rec,
        startTime: new Date(rec.startTime),
        endTime: new Date(rec.endTime),
      }));

      logDev('ScheduleRecommendations', 'AI 時間建議獲取成功', {
        count: recommendations.length,
      });

      return recommendations;
    } catch (error) {
      logError('獲取 AI 時間建議失敗', error);
      throw error;
    }
  },
};
